<div class="profile-section">
  <!-- Header -->
  <div class="header">
    <div class="nav-back" (click)="onGoBack()">
      <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.35355 0.646447C5.54882 0.841709 5.54882 1.15829 5.35355 1.35355L1.20711 5.5L5.35355 9.64645C5.54882 9.84171 5.54882 10.1583 5.35355 10.3536C5.15829 10.5488 4.84171 10.5488 4.64645 10.3536L0.146447 5.85355C-0.0488156 5.65829 -0.0488156 5.34171 0.146447 5.14645L4.64645 0.646447C4.84171 0.451184 5.15829 0.451184 5.35355 0.646447Z" fill="#134F82"/>
      </svg>
      <span>Perfil</span>
    </div>

    <div class="title-section">
      <div class="title-with-icon">
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none">
          <path d="M3.75 9.5C3.33579 9.5 3 9.83579 3 10.25C3 10.6642 3.33579 11 3.75 11C4.16421 11 4.5 10.6642 4.5 10.25C4.5 9.83579 4.16421 9.5 3.75 9.5ZM3 13.25C3 12.8358 3.33579 12.5 3.75 12.5C4.16421 12.5 4.5 12.8358 4.5 13.25C4.5 13.6642 4.16421 14 3.75 14C3.33579 14 3 13.6642 3 13.25ZM6 10.25C6 9.83579 6.33579 9.5 6.75 9.5H9.80375C10.218 9.5 10.5538 9.83579 10.5538 10.25C10.5538 10.6642 10.218 11 9.80375 11H6.75C6.33579 11 6 10.6642 6 10.25ZM6.75 12.5C6.33579 12.5 6 12.8358 6 13.25C6 13.6642 6.33579 14 6.75 14H9.80375C10.218 14 10.5538 13.6642 10.5538 13.25C10.5538 12.8358 10.218 12.5 9.80375 12.5H6.75ZM2.25 0C1.00736 0 0 1.00736 0 2.25V15.25C0 16.4926 1.00736 17.5 2.25 17.5H11.25C12.4926 17.5 13.5 16.4926 13.5 15.25V6.86885C13.5 6.27211 13.2629 5.69981 12.841 5.27786L8.22214 0.65901C7.80019 0.237053 7.22789 0 6.63115 0H2.25ZM1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H6.50391V4.74753C6.50391 5.99017 7.51127 6.99753 8.75391 6.99753H12V15.25C12 15.6642 11.6642 16 11.25 16H2.25C1.83579 16 1.5 15.6642 1.5 15.25V2.25ZM8.00391 4.74753V2.56209L10.9393 5.49753H8.75391C8.33969 5.49753 8.00391 5.16174 8.00391 4.74753ZM4.75088 20C3.77121 20 2.93778 19.3739 2.62891 18.5H11.2509C13.0458 18.5 14.5009 17.0449 14.5009 15.25V6.93689L15.3419 7.77788C15.7638 8.19984 16.0009 8.77213 16.0009 9.36887V15.25C16.0009 17.8734 13.8742 20 11.2509 20H4.75088Z" fill="#208FE4"/>
        </svg>
        <h1>Registros</h1>
      </div>
    </div>
  </div>

  <!-- Sección Mascotas -->
  <!--div class="category-section">
    <div class="category-header">
      <h2>Mascotas</h2-->
      <!-- Botón para desktop -->
      <!--button class="add-category-btn desktop-add-btn" (click)="onAddMascota()">
        <span>Agregar mascota</span>
      </button>
    </div>

    <div class="cards-grid">
      <div class="card" *ngFor="let mascota of mascotas">
        <div class="card-header">
          <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 2.75C5.5 1.98456 6.01725 1.5 6.5 1.5C6.98275 1.5 7.5 1.98456 7.5 2.75C7.5 3.51544 6.98275 4 6.5 4C6.01725 4 5.5 3.51544 5.5 2.75ZM6.5 0.5C5.3259 0.5 4.5 1.58245 4.5 2.75C4.5 3.91755 5.3259 5 6.5 5C7.6741 5 8.5 3.91755 8.5 2.75C8.5 1.58245 7.6741 0.5 6.5 0.5ZM2 4C1.51725 4 1 4.48456 1 5.25C1 6.01544 1.51725 6.5 2 6.5C2.48275 6.5 3 6.01544 3 5.25C3 4.48456 2.48275 4 2 4ZM0 5.25C0 4.08245 0.825897 3 2 3C3.1741 3 4 4.08245 4 5.25C4 6.41755 3.1741 7.5 2 7.5C0.825897 7.5 0 6.41755 0 5.25ZM16 4C15.5172 4 15 4.48456 15 5.25C15 6.01544 15.5172 6.5 16 6.5C16.4828 6.5 17 6.01544 17 5.25C17 4.48456 16.4828 4 16 4ZM14 5.25C14 4.08245 14.8259 3 16 3C17.1741 3 18 4.08245 18 5.25C18 6.41755 17.1741 7.5 16 7.5C14.8259 7.5 14 6.41755 14 5.25ZM11.5 1.5C11.0172 1.5 10.5 1.98456 10.5 2.75C10.5 3.51544 11.0172 4 11.5 4C11.9828 4 12.5 3.51544 12.5 2.75C12.5 1.98456 11.9828 1.5 11.5 1.5ZM9.5 2.75C9.5 1.58245 10.3259 0.5 11.5 0.5C12.6741 0.5 13.5 1.58245 13.5 2.75C13.5 3.91755 12.6741 5 11.5 5C10.3259 5 9.5 3.91755 9.5 2.75ZM4 12.5C4 9.73858 6.23858 7.5 9 7.5C11.7614 7.5 14 9.73858 14 12.5C14 13.1064 13.7026 13.59 13.2104 13.9397C12.708 14.2965 12.0145 14.5 11.3052 14.5H6.69479C5.98546 14.5 5.29199 14.2965 4.78964 13.9397C4.29742 13.59 4 13.1064 4 12.5ZM9 6.5C5.68629 6.5 3 9.18629 3 12.5C3 13.4864 3.50358 14.2528 4.21055 14.7549C4.90741 15.2499 5.81133 15.5 6.69479 15.5H11.3052C12.1887 15.5 13.0926 15.2499 13.7894 14.7549C14.4964 14.2528 15 13.4864 15 12.5C15 9.18629 12.3137 6.5 9 6.5Z" fill="#166DB3"/>
          </svg>
          <h3>{{mascota.petName}}</h3>

          <div class="actions">
            <div class="action-btn" (click)="onEdit(mascota, 'mascota')">
              <span>Editar</span>
              <svg viewBox="0 0 14 15" fill="none">
                <path d="M13.236 1.26386C12.2123 0.240172 10.5525 0.240171 9.52885 1.26386L1.65722 9.13549C1.28304 9.50967 1.01623 9.97748 0.88467 10.49L0.0157097 13.8755C-0.0282329 14.0467 0.0214766 14.2284 0.146457 14.3534C0.271438 14.4783 0.453118 14.528 0.624318 14.4841L4.00978 13.6151C4.52234 13.4836 4.99015 13.2168 5.36433 12.8426L13.236 4.97097C14.2596 3.94728 14.2596 2.28755 13.236 1.26386ZM10.236 1.97097C10.8691 1.3378 11.8957 1.3378 12.5288 1.97097C13.162 2.60413 13.162 3.6307 12.5288 4.26386L11.75 5.04269L9.45713 2.74979L10.236 1.97097ZM8.75002 3.4569L11.0429 5.74979L4.65722 12.1355C4.40969 12.383 4.10023 12.5595 3.76117 12.6465L1.19447 13.3053L1.85327 10.7386C1.9403 10.3996 2.1168 10.0901 2.36433 9.84259L8.75002 3.4569Z" fill="#134F82"/>
              </svg>
            </div>

            <div class="divider"></div>

            <div class="action-btn" (click)="onDelete(mascota, 'mascota')">
              <svg viewBox="0 0 14 15" fill="none">
                <path d="M6 2.5H8C8 1.94772 7.55228 1.5 7 1.5C6.44772 1.5 6 1.94772 6 2.5ZM5 2.5C5 1.39543 5.89543 0.5 7 0.5C8.10457 0.5 9 1.39543 9 2.5H13C13.2761 2.5 13.5 2.72386 13.5 3C13.5 3.27614 13.2761 3.5 13 3.5H12.4364L11.2313 12.3378C11.0624 13.5765 10.0044 14.5 8.75422 14.5H5.24578C3.99561 14.5 2.93762 13.5765 2.76871 12.3378L1.56355 3.5H1C0.723858 3.5 0.5 3.27614 0.5 3C0.5 2.72386 0.723858 2.5 1 2.5H5ZM6 6C6 5.72386 5.77614 5.5 5.5 5.5C5.22386 5.5 5 5.72386 5 6V11C5 11.2761 5.22386 11.5 5.5 11.5C5.77614 11.5 6 11.2761 6 11V6ZM8.5 5.5C8.77614 5.5 9 5.72386 9 6V11C9 11.2761 8.77614 11.5 8.5 11.5C8.22386 11.5 8 11.2761 8 11V6C8 5.72386 8.22386 5.5 8.5 5.5ZM3.75954 12.2027C3.86089 12.9459 4.49568 13.5 5.24578 13.5H8.75422C9.50432 13.5 10.1391 12.9459 10.2405 12.2027L11.4272 3.5H2.57281L3.75954 12.2027Z" fill="#134F82"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="card-content">
          <div class="detail">
            <span class="label">Especie:</span>
            <span class="value">{{mascota.specie}}</span>
          </div>
          <div class="detail">
            <span class="label">Raza:</span>
            <span class="value">{{mascota.breed}}</span>
          </div>
          <div class="detail">
            <span class="label">Género:</span>
            <span class="value">{{mascota.gender}}</span>
          </div>
          <div class="detail">
            <span class="label">Edad:</span>
            <span class="value">{{mascota.age}} años</span>
          </div>
          <div class="detail">
            <span class="label">Peso:</span>
            <span class="value">{{mascota.weight}} kg</span>
          </div>
        </div>
      </div>
    </div-->

    <!-- Botón móvil para mascotas -->
    <!--button class="mobile-add-btn" (click)="onAddMascota()">
      <span>Agregar mascota</span>
    </button>
  </div-->

  <!-- Sección Vehículos -->
  <div class="category-section">
    <div class="category-header">
      <h2>Vehículos</h2>
      <!-- Botón para desktop -->
      <button class="add-category-btn desktop-add-btn" (click)="onAddVehiculo()">
        <span>Agregar vehículo</span>
      </button>
    </div>

    <div class="cards-grid">
      <div class="card" *ngFor="let vehiculo of vehiculos">
        <div class="card-header">
          <svg width="16" height="13" viewBox="0 0 16 13" fill="none">
            <path d="M3.51849 2.52566L2.86038 4.5H6V1.5H4.94152C4.29587 1.5 3.72267 1.91314 3.51849 2.52566ZM2.52705 5.5L2.52391 5.50941L2.25763 5.57598L2.1362 5.60634C1.46845 5.77328 1 6.37325 1 7.06155V8.75C1 8.91087 1.05065 9.05992 1.13687 9.18205C1.47569 8.20303 2.40574 7.5 3.5 7.5C4.70948 7.5 5.71836 8.35888 5.94999 9.5H10.05C10.2816 8.35888 11.2905 7.5 12.5 7.5C13.5943 7.5 14.5243 8.20303 14.8631 9.18205C14.9494 9.05992 15 8.91087 15 8.75V7.53656C15 6.85698 14.5431 6.26231 13.8865 6.0872L11.6845 5.5H2.52705ZM10.8725 4.5L9.63443 2.27154C9.36987 1.79534 8.86794 1.5 8.32319 1.5H7V4.5H10.8725ZM16 8.75C16 9.45722 15.5805 10.0665 14.9767 10.3424C14.8098 11.5611 13.7645 12.5 12.5 12.5C11.2905 12.5 10.2816 11.6411 10.05 10.5H5.94999C5.71836 11.6411 4.70948 12.5 3.5 12.5C2.23545 12.5 1.19019 11.5611 1.02326 10.3424C0.41951 10.0665 0 9.45722 0 8.75V7.06155C0 5.96543 0.712801 5.00372 1.74709 4.67758L2.56981 2.20943C2.9101 1.18857 3.86544 0.5 4.94152 0.5H8.32319C9.23111 0.5 10.0677 0.99223 10.5086 1.78589L12.0514 4.56289L14.1442 5.12097C15.2385 5.4128 16 6.40393 16 7.53656V8.75ZM3.5 8.5C2.67157 8.5 2 9.17157 2 10C2 10.8284 2.67157 11.5 3.5 11.5C4.32843 11.5 5 10.8284 5 10C5 9.17157 4.32843 8.5 3.5 8.5ZM12.5 8.5C11.6716 8.5 11 9.17157 11 10C11 10.8284 11.6716 11.5 12.5 11.5C13.3284 11.5 14 10.8284 14 10C14 9.17157 13.3284 8.5 12.5 8.5Z" fill="#166DB3"/>
          </svg>
          <h3>{{vehiculo.catalogbrand.description}} {{vehiculo.model}}</h3>

          <div class="actions">
            <div class="action-btn" (click)="onEdit(vehiculo, 'vehiculo')">
              <span>Editar</span>
              <svg viewBox="0 0 14 15" fill="none">
                <path d="M13.236 1.26386C12.2123 0.240172 10.5525 0.240171 9.52885 1.26386L1.65722 9.13549C1.28304 9.50967 1.01623 9.97748 0.88467 10.49L0.0157097 13.8755C-0.0282329 14.0467 0.0214766 14.2284 0.146457 14.3534C0.271438 14.4783 0.453118 14.528 0.624318 14.4841L4.00978 13.6151C4.52234 13.4836 4.99015 13.2168 5.36433 12.8426L13.236 4.97097C14.2596 3.94728 14.2596 2.28755 13.236 1.26386ZM10.236 1.97097C10.8691 1.3378 11.8957 1.3378 12.5288 1.97097C13.162 2.60413 13.162 3.6307 12.5288 4.26386L11.75 5.04269L9.45713 2.74979L10.236 1.97097ZM8.75002 3.4569L11.0429 5.74979L4.65722 12.1355C4.40969 12.383 4.10023 12.5595 3.76117 12.6465L1.19447 13.3053L1.85327 10.7386C1.9403 10.3996 2.1168 10.0901 2.36433 9.84259L8.75002 3.4569Z" fill="#134F82"/>
              </svg>
            </div>

            <div class="divider"></div>

            <div class="action-btn" (click)="onDelete(vehiculo, 'vehiculo')">
              <svg viewBox="0 0 14 15" fill="none">
                <path d="M6 2.5H8C8 1.94772 7.55228 1.5 7 1.5C6.44772 1.5 6 1.94772 6 2.5ZM5 2.5C5 1.39543 5.89543 0.5 7 0.5C8.10457 0.5 9 1.39543 9 2.5H13C13.2761 2.5 13.5 2.72386 13.5 3C13.5 3.27614 13.2761 3.5 13 3.5H12.4364L11.2313 12.3378C11.0624 13.5765 10.0044 14.5 8.75422 14.5H5.24578C3.99561 14.5 2.93762 13.5765 2.76871 12.3378L1.56355 3.5H1C0.723858 3.5 0.5 3.27614 0.5 3C0.5 2.72386 0.723858 2.5 1 2.5H5ZM6 6C6 5.72386 5.77614 5.5 5.5 5.5C5.22386 5.5 5 5.72386 5 6V11C5 11.2761 5.22386 11.5 5.5 11.5C5.77614 11.5 6 11.2761 6 11V6ZM8.5 5.5C8.77614 5.5 9 5.72386 9 6V11C9 11.2761 8.77614 11.5 8.5 11.5C8.22386 11.5 8 11.2761 8 11V6C8 5.72386 8.22386 5.5 8.5 5.5ZM3.75954 12.2027C3.86089 12.9459 4.49568 13.5 5.24578 13.5H8.75422C9.50432 13.5 10.1391 12.9459 10.2405 12.2027L11.4272 3.5H2.57281L3.75954 12.2027Z" fill="#134F82"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="card-content">
          <div class="detail">
            <span class="label">Marca:</span>
            <span class="value">{{vehiculo.catalogbrand.description}}</span>
          </div>
          <div class="detail">
            <span class="label">Submarca:</span>
            <span class="value">{{vehiculo.catalogsubbrand.description}}</span>
          </div>
          <div class="detail">
            <span class="label">Modelo:</span>
            <span class="value">{{vehiculo.model}}</span>
          </div>
          <div class="detail">
            <span class="label">Placas:</span>
            <span class="value">{{vehiculo.plates}}</span>
          </div>
          <div class="detail">
            <span class="label">Color:</span>
            <span class="value">{{vehiculo.colorcatalog.description}}</span>
          </div>
          <div class="detail">
            <span class="label">Número de serie:</span>
            <span class="value">{{vehiculo.serialNumber}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Botón móvil para vehículos -->
    <button class="mobile-add-btn" (click)="onAddVehiculo()">
      <span>Agregar vehículo</span>
    </button>
  </div>
</div>
